import "./index.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import ProtectForm from "./pages/ProtectFormPage";
import TermOfServices from "./pages/TermOfServices";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PaymentLoading from "./pages/PaymentLoading";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentFailure from "./pages/PaymentFailure";
import PinCodeSearch from "./pages/PinCode";

function App() {
  return (
    <>
      <Router>
        <Routes>
          {/* Home Page */}
          <Route path="/" element={<ProtectForm />} />

          <Route path="/payment-process" element={<PaymentLoading />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failure" element={<PaymentFailure />} />
          <Route path="/payment-url" element={<PaymentFailure />} />

          {/* Terms of Service */}
          <Route path="/terms-of-service" element={<TermOfServices />} />

          {/* Privacy Policy */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/pin-code" element={<PinCodeSearch />} />
        </Routes>
      </Router>
      <ToastContainer position="top-right" autoClose={3000} />
    </>
  );
}

export default App;
